import { Box, Button, Spacer, Text } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { FC, useEffect, useState } from 'react'
import { TransactionsType } from '../../screens/TransactionNew/types'
import { Colors } from '../../util/util'
import { Checkbox } from '../Checkbox'
import { styles } from './styles'

interface FieldSettingProp {
  settingData: any
  toggleFieldSettings: () => void
  staticStrings: any
  onReset: () => void
  apply: (data: string[]) => void
  onSelectAll?: any
  updateAllFieldsSelected?: any
  allFieldsSelected: boolean
  path?: string
  onSubscrptionFieldsSelectAll?: any
}
interface FieldItemProp {
  handleChecked: (data: any) => void
  data: any
  show: boolean
  getCheckedState: string[]
}

const titlemap = {
  ERN: 'Merchant Ref No',
  RRN: 'JioPay Id',
  'Acq Terminal': 'Terminal id',
}

const getTitle = (title: string) => {
  if (title in titlemap) {
    return titlemap[title as keyof typeof titlemap]
  }
  return title
}

const FieldItem: FC<FieldItemProp> = ({ handleChecked, data, show = true, getCheckedState }: FieldItemProp) => {
  if (!show) {
    return null
  }

  const haddleClick = (): void => {
    handleChecked(data.id)
  }
  return (
    <Box
      disabled={data.isDisable}
      {...styles.child}
      testID="field-settings"
      onPress={haddleClick}
      key={getRandomAlphaNumString(4)}>
      <Checkbox
        disabled={data.isDisable}
        isChecked={getCheckedState.includes(data?.id)}
        onPress={haddleClick}
        color={'BLUE'}
      />
      <Spacer direction="horizontal" size={10} />
      <Text type={'caption'} color={Colors.BLACK} fontWeight="600">
        {getTitle(data.title)}
      </Text>
    </Box>
  )
}

const FieldSetting: FC<FieldSettingProp> = ({
  settingData,
  toggleFieldSettings,
  staticStrings,
  onReset,
  apply,
  onSelectAll,
  onSubscrptionFieldsSelectAll,
  updateAllFieldsSelected,
  allFieldsSelected,
  path,
}: FieldSettingProp) => {
  const [initialColumns, setInitialColumns] = useState<string[]>([])
  const [fields, setFields] = useState(settingData)

  useEffect(() => {
    setInitialColumns(
      fields?.map((item: any) => {
        if (item.isChecked) {
          return item?.id
        }
      }) ?? [],
    )
  }, [fields])

  const handleChecked = (newvalue: string): void => {
    if (initialColumns.includes(newvalue)) {
      const newCol = initialColumns.filter((e: string) => e !== newvalue)
      setInitialColumns([...newCol])
      updateAllFieldsSelected(false)
    } else {
      const allChecked = fields?.length === initialColumns?.length + 1
      allChecked && updateAllFieldsSelected(true)
      setInitialColumns([...initialColumns, newvalue])
    }
  }

  const onCancel = (): void => {
    toggleFieldSettings()
  }

  const onApply = (): void => {
    toggleFieldSettings()
    apply(initialColumns)
  }

  const showField = (data: any): boolean => {
    if (data.id === 'id' || data.id === 'action') {
      return false
    }
    return true
  }

  const handleSelectAll = () => {
    updateAllFieldsSelected(!allFieldsSelected)
    if (path === TransactionsType.subscriptions) {
      const allFields = onSubscrptionFieldsSelectAll(!allFieldsSelected)
      setFields(allFields)
    } else {
      const allFields = onSelectAll(!allFieldsSelected)
      setFields(allFields)
    }
  }

  return (
    <Box {...styles.outerContainer}>
      <Box {...styles.topBar}>
        <Text type={'title18'}>{staticStrings.fieldSettings}</Text>
        <Spacer size={6} />
        <Text type={'footnote'} fontWeight="500" color={Colors.OTP_GREY}>
          {staticStrings.fieldSettingsSubHeader}
        </Text>
        <Spacer size={6} />
      </Box>
      <Box {...styles.container} pt={16}>
        <Checkbox title={'Select All'} isChecked={allFieldsSelected} onPress={handleSelectAll} />
      </Box>
      <Box {...styles.container} ph={8}>
        {fields.map((data: any) => (
          <FieldItem
            data={data}
            handleChecked={handleChecked}
            show={showField(data)}
            getCheckedState={initialColumns}
            key={getRandomAlphaNumString(3)}
          />
        ))}
      </Box>
      <Box {...styles.bottomBar}>
        <Box {...styles.resetContainer}>
          <Button
            onPress={onReset}
            testID="reset-filed-setting"
            type="IconLH"
            textColor={'BLUE'}
            title={staticStrings.resetFields}
          />
        </Box>
        <Box {...styles.headerContainer}>
          <Button
            onPress={onCancel}
            testID="cancel-filed-setting"
            type={'IconLH'}
            color={Colors.TRANSPARENT}
            textColor={'BLUE'}
            title={staticStrings.cancel}
          />
          <Spacer direction="horizontal" size={16} />
          <Button onPress={onApply} testID="apply-test" type={'SecondaryWithBg'} title={staticStrings.apply} />
        </Box>
      </Box>
    </Box>
  )
}

export default FieldSetting
